<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import RbxDatePicker from '../../../shared/reybex/RbxDatePicker';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';

export default {
  name: 'CompanyPrivacyOfficerForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxDatePicker,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'company',
      showDateMenu: false,
    };
  },
  created() {
    if (!this.company.privacyOfficer) {
      this.company.privacyOfficer = {};
    }
  },
  methods: {
    onDateInput(newDate) {
      this.company.privacyOfficer.requestDate = newDate;
    },
  },
};
</script>

<template>
  <div class="company-detail-tab main-tab">
    <v-layout row wrap>
      <!-- Basic information left column -->
      <v-flex md8 xs12>
        <h4 class="company-detail-tab-title">Allgemein</h4>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('company.privacyOfficer.name')" md4 py-0>
            <v-text-field
              v-model="company.privacyOfficer.name"
              label="Name des Datenschutzbeauftragten"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.privacyOfficer.firm')" md4 py-0>
            <v-text-field
              v-model="company.privacyOfficer.firm"
              label="Firma"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.privacyOfficer.street')" md4 py-0>
            <v-text-field
              v-model="company.privacyOfficer.street"
              label="Straße"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.privacyOfficer.zip')" md4 py-0>
            <v-text-field
              v-model="company.privacyOfficer.zip"
              label="PLZ"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.privacyOfficer.location')" md4 py-0>
            <v-text-field
              v-model="company.privacyOfficer.location"
              label="Ort"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.privacyOfficer.phone')" md4 py-0>
            <v-text-field
              v-model="company.privacyOfficer.phone"
              label="Telefon"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.privacyOfficer.fax')" md4 py-0>
            <v-text-field
              v-model="company.privacyOfficer.fax"
              label="Fax"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.privacyOfficer.email')" md4 py-0>
            <v-text-field
              v-model="company.privacyOfficer.email"
              label="E-Mail-Adresse"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.privacyOfficer.requestDate')" md4 py-0>
            <rbx-date-picker
              label="Bestellungsdatum zum Datenschutzbeauftragten"
              :value="company.privacyOfficer.requestDate"
              @input="onDateInput"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('company.privacyOfficer.isInternal')" md4 py-0>
            <v-switch
              v-model="company.privacyOfficer.isInternal"
              label="intern Angestellt"
              height="0"
            />
          </v-flex>

        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
